import 'reflect-metadata';
import {
  Expose,
  plainToInstance,
  instanceToPlain,
  Type,
} from 'class-transformer';

export class PvHistoryPaginated {
  @Type(() => PvHistoryItem)
  items: PvHistoryItem[];

  @Expose({ name: 'next_page_url' })
  nextPageUrl?: string;

  constructor(items: PvHistoryItem[], nextPageUrl?: string) {
    this.items = items;
    this.nextPageUrl = nextPageUrl;
  }

  get cursor(): string | null {
    return this.nextPageUrl == null
      ? null
      : new URL(this.nextPageUrl).searchParams.get('cursor');
  }

  static fromJson(json: Record<string, any>): PvHistoryPaginated {
    return plainToInstance(PvHistoryPaginated, json);
  }

  toJson(): any {
    return instanceToPlain(this);
  }
}

export class PvHistoryItem {
  id: number;

  pv: string;

  tv: string;

  @Expose({ name: 'total_pv' })
  totalPv: string;

  @Expose({ name: 'total_tv' })
  totalTv: string;

  type: string;

  @Expose({ name: 'created_at' })
  @Type(() => Date)
  dateCreated: Date;

  @Expose({ name: 'from_username' })
  fromUser: string;

  constructor(
    id: number,
    pv: string,
    tv: string,
    totalPv: string,
    totalTv: string,
    type: string,
    dateCreated: Date,
    fromUser: string
  ) {
    this.id = id;
    this.pv = pv;
    this.tv = tv;
    this.totalPv = totalPv;
    this.totalTv = totalTv;
    this.type = type;
    this.dateCreated = dateCreated;
    this.fromUser = fromUser;
  }

  static fromJson(json: Record<string, any>): PvHistoryItem {
    return plainToInstance(PvHistoryItem, json);
  }

  toJson(): any {
    return instanceToPlain(this);
  }
}
